import { render, staticRenderFns } from "./FoodKindTastes.vue?vue&type=template&id=1d0a0fa0&"
import script from "./FoodKindTastes.vue?vue&type=script&lang=js&"
export * from "./FoodKindTastes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports